import styles from "./NoForm.module.scss";
import React from "react";
import classNames from "classnames";

const NoForm = ({style, className, children}) => {
    return <form className={classNames(className, styles.base)} style={style} onSubmit={e => {
        e.preventDefault();
        return false;
    }}>
        {children}
    </form>
}

export default NoForm;